import React, { createContext, useEffect, useState } from 'react';
import api from '../services/api';

export const AuthContext = createContext();
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // ilk yüklemede kontrol için
  const login = async (token) => {
    localStorage.setItem('token', token);
    try {
      const res = await api.get('/users/me');
      setUser({
        id: res.data.id,
        email: res.data.email,
        role: res.data.role,
        is_active: res.data.is_active,
        first_name:res.data.first_name,
        last_name:res.data.last_name
      });
      return res
    } catch (err) {
      logout();
      throw err;
    }
  };
  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  // 🔄 Sayfa yenilendiğinde token varsa kullanıcıyı tekrar getir
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.get('/users/me')
        .then((res) => {
          setUser({
            id: res.data.id,
            email: res.data.email,
            role: res.data.role,
            is_active: res.data.is_active,
            first_name:res.data.first_name,
            last_name:res.data.last_name
          });
        })
        .catch(() => {
          logout();
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  // Loading bitmeden sayfaları göstermeyelim
  if (loading) {
    return <div>Yükleniyor...</div>;
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
